// App navbar, plan constants, 用户管理, AI 点评标准
const en = {
  // App.js
  "乡土智课系统": "Local Curriculum Studio",
  "我的乡土课程": "My Courses",
  "我的点评": "My Reviews",
  "待点评案例": "Awaiting Review",
  "全部乡土课程": "All Courses",
  "数据看板": "Dashboard",
  "用户管理": "Users",
  "课外读物推荐": "Reading List",
  "模板管理": "Templates",
  "AI 点评标准": "AI Review Rubric",
  "AI 打分加点评": "AI Scoring & Review",
  "学习资源库": "Resource Library",
  "教师分享": "Teacher Shares",
  "课程案例库": "Course Gallery",
  "退出": "Log out",
  "登录": "Log in",
  "注册": "Sign up",

  // plan-options.js
  "上传文件": "Upload file",
  "在线填写": "Fill in online",
  "草稿": "Draft",
  "已提交": "Submitted",
  "已点评": "Reviewed",
  "确定删除该课程设计吗？删除后将移入回收站，{PLAN_TRASH_RETENTION_DAYS} 天内可在回收站中恢复，之后将永久删除。":
    "Delete this course design? It will be moved to the Trash, where it can be restored within {PLAN_TRASH_RETENTION_DAYS} days before being permanently deleted.",

  // admin-users-list
  "教师": "Teacher",
  "专家": "Expert",
  "管理员": "Admin",
  "超级管理员": "Super admin",
  "主动退出": "Logged out",
  "用户主动点击退出登录": "The user clicked Log out",
  "超时退出": "Timed out",
  "长时间无操作，登录已超时自动失效": "The session expired after a long period of inactivity",
  "0分钟": "0 min",
  "{hours}小时{minutes}分钟": "{hours} h {minutes} min",
  "{hours}小时": "{hours} h",
  "{minutes}分钟": "{minutes} min",
  "加载用户列表失败。": "Failed to load users.",
  "导出 Excel 失败。": "Excel export failed.",
  "加载该校课程计划失败。": "Failed to load this school's courses.",
  "请至少选择一个角色。": "Please select at least one role.",
  "教师角色必须选择所在学校。": "Teachers must have a school selected.",
  "用户信息更新成功。": "User updated.",
  "用户创建成功。": "User created.",
  "更新失败。": "Update failed.",
  "创建失败。": "Create failed.",
  "确定停用用户「{0}」吗？停用后该用户将无法登录。": "Deactivate user \"{0}\"? They will no longer be able to log in.",
  "操作失败。": "Operation failed.",
  "确定取消「{name}」的种子教师标记吗？": "Remove the seed-teacher flag from \"{name}\"?",
  "此操作将永久删除用户「{0}」，且无法撤销。确定继续吗？": "This will permanently delete user \"{0}\" and cannot be undone. Continue?",
  "用户删除成功。": "User deleted.",
  "删除失败。": "Delete failed.",
  "无权限访问此页面，仅超级管理员可用。": "You don't have access to this page. Super admins only.",
  "用户管理（总数：{totalItems}）": "Users (total: {totalItems})",
  "导出字段（{effectiveExportFields.length}）": " Export fields ({effectiveExportFields.length})",
  "导出中...": "Exporting...",
  "导出 Excel（{totalItems} 行）": "Export Excel ({totalItems} rows)",
  "选择导出到 Excel 的字段": "Choose the fields to export to Excel",
  "全选": "Select all",
  "全不选": "Select none",
  "恢复默认": "Reset to default",
  "导出当前筛选结果（全部分页），按当前排序。": "Exports the current filtered results (all pages) in the current sort order.",
  "按用户名/姓名/邮箱搜索": "Search by username / name / email",
  "全部角色": "All roles",
  "全部状态": "All statuses",
  "正常": "Active",
  "已停用": "Deactivated",
  "全部教师": "All teachers",
  "种子教师": " Seed teachers",
  "非种子教师": "Non-seed teachers",
  "搜索": "Search",
  "按学校筛选（可按编号/名称/地址搜索）...": "Filter by school (search by code / name / address)...",
  "全部在线状态": "Any online status",
  "在线": "Online",
  "离线": "Offline",
  "全部退出方式": "Any logout type",
  "AI 用量，单位：万 tokens": "AI usage, in units of 10k tokens",
  "AI 用量（万）": "AI usage (×10k)",
  "最低": "Min",
  "最高": "Max",
  "新增管理员 / 用户": "Add admin / user",
  "用户名": "Username ",
  "姓名": "Name ",
  "邮箱": "Email",
  "角色": "Role",
  "学校编号": "School code ",
  "邮箱已验证": " Email verified",
  "状态": "Status",
  "注册时间": "Registered ",
  "上次登录时间": "Last login ",
  "退出时间": "Logged out at",
  "累计登录时长": "Total time logged in ",
  "累计消耗的 AI tokens（欣欣小助手、AI 点评等）": "Total AI tokens used (Xinxin Assistant, AI reviews, etc.)",
  "AI 用量": "AI usage ",
  "操作": "Actions",
  "种子": "Seed",
  "是": "Yes",
  "否": "No",
  "从未登录": "Never logged in",
  "（当前账号）": " (you)",
  "编辑": "Edit",
  "启用": "Activate",
  "停用": "Deactivate",
  "取消种子": "Unset seed",
  "设为种子": "Set as seed",
  "删除": " Delete",
  "暂无数据": "No data",
  "每页条数": "Rows per page",
  "学校信息": "School info",
  "关闭": "Close",
  "学校名称": "School name",
  "地址": "Address",
  "该校课程计划（{schoolPlans.length}）": "This school's courses ({schoolPlans.length})",
  "加载中...": "Loading...",
  "暂无课程计划。": "No courses yet.",
  "未命名课程设计": "Untitled course design",
  "未找到编号为 {schoolDetailCode} 的学校。": "No school found with code {schoolDetailCode}.",
  "编辑用户": "Edit user",
  "新增用户": "Add user",
  "电话": "Phone",
  "新密码（留空则不修改）": "New password (leave blank to keep)",
  "密码": "Password ",
  "管理员创建的账号无需邮箱验证，创建后即可直接登录。": "Accounts created by an admin don't need email verification and can log in right away.",
  "所在学校": "School ",
  "搜索并选择学校...": "Search and select a school...",
  "保存": "Save",
  "创建": "Create",
  "取消": "Cancel",

  // ai-review-standard
  "错误": "Error",
  "注意": "Note",
  "高": "High",
  "中": "Medium",
  "低": "Low",
  "AI 核查：{ai.summary}": "AI check: {ai.summary}",
  "未发现问题。": "No issues found.",
  "结构核查": "Structure check",
  "AI 核查（对照学习资源库）": "AI check (against the Resource Library)",
  "风险": "Risk",
  "变化：{c.change}": "Change: {c.change}",
  "依据资料（资料中已有的评价标准 {retrieval.anchors.length} 份，共引用 {count} 项）":
    "Sources ({retrieval.anchors.length} existing rubrics in the materials, {count} items cited)",
  "资料中已有的评价标准（原文引用，作为标准骨架）": "Existing rubrics in the materials (quoted verbatim, used as the rubric's skeleton)",
  "原文引用": "Verbatim quote",
  "语义匹配片段（原文引用）": "Semantically matched passages (verbatim)",
  " · {v.topic} · 相似度 {v.score}": " · {v.topic} · similarity {v.score}",
  "摘要引用": "Summary excerpts",
  "背景主题": "Background topics",
  "评分维度": "Scoring dimension",
  "分值": "Points",
  "评分要点": "Scoring criteria",
  "等级描述": "Level descriptors",
  "依据：{d.basis}": "Basis: {d.basis}",
  "评分说明": "Scoring notes",
  "标题": "Title",
  "总体说明": "Overview",
  "分值合计：{total} / {draft.totalScore}": "Points total: {total} / {draft.totalScore}",
  "维度名称": "Dimension name",
  "删除此维度": "Delete this dimension",
  "考察内容": "What it assesses",
  "依据": "Basis",
  "评分要点（每行一条）": "Scoring criteria (one per line)",
  "等级": "Level",
  "如 18-20": "e.g. 18-20",
  "判定描述": "Descriptor",
  "删除此等级": "Delete this level",
  "+ 添加等级": "+ Add level",
  "+ 添加评分维度": "+ Add scoring dimension",
  "评分说明（每行一条）": "Scoring notes (one per line)",
  "生成失败：{lastError}": "Generation failed: {lastError}",
  "AI 点评仅对专家和管理员开放。": "AI review is available to experts and admins only.",
  "放弃未保存的修订吗？": "Discard unsaved revisions?",
  "已完成核查，请查看下方提醒后再次点击「保存为新版本」。": "Check complete. Review the notes below, then click \"Save as new version\" again.",
  "核查共提出 {n} 条提醒。确定仍要保存为新版本并立即生效吗？": "The check raised {n} notes. Save as a new version and make it active anyway?",
  "导出失败。": "Export failed.",
  "有未保存的标准修订，确定要离开吗？": "You have unsaved rubric revisions. Leave anyway?",
  "版本历史（{versions.length}）": "Version history ({versions.length})",
  "将版本 #{shown.id} 导出为 Word 文档": "Export version #{shown.id} as a Word document",
  "导出中…": "Exporting…",
  "导出 Word": " Export Word",
  "基于此版本修订": "Revise from this version",
  "修订标准": "Revise rubric",
  "当前生效的标准包含人工修订，重新生成将由 AI 从学习资源库重新制定，不会保留这些修订。确定继续吗？":
    "The active rubric includes manual revisions. Regenerating has AI rebuild it from the Resource Library and those revisions will not be kept. Continue?",
  "将基于学习资源库的当前内容重新生成评分标准，之后的 AI 点评将采用新标准。确定继续吗？":
    "The rubric will be regenerated from the current Resource Library, and future AI reviews will use the new rubric. Continue?",
  "生成中…": "Generating…",
  "重新生成": "Regenerate",
  "生成标准": "Generate rubric",
  "正在分析、综合学习资源库中的材料以生成评分标准，通常需要一到两分钟…":
    " Analyzing and synthesizing the Resource Library materials to generate the rubric. This usually takes a minute or two…",
  "版本 #{v.id}": "Version #{v.id}",
  "当前生效": "Active",
  "人工修订{0}，基于 #{v.baseId}": "Manually revised{0}, based on #{v.baseId}",
  "AI 生成": "AI generated",
  "暂无评分标准。": "No rubric yet.",
  "正在基于版本 #{baseId} 修订。保存前会进行结构核查，并由 AI 对照学习资源库检查修订是否有材料依据；保存后将成为新的生效版本，并记录您为修订人。":
    "Revising from version #{baseId}. Before saving, a structure check runs and AI checks the revision against the Resource Library for supporting material. Once saved it becomes the active version, with you recorded as the reviser.",
  "修订说明": "Revision note",
  "说明本次修订的内容与理由": "Describe what changed and why",
  "AI 正在对照学习资源库核查本次修订，可能需要一分钟左右…": " AI is checking this revision against the Resource Library. This may take about a minute…",
  "AI 核查": "AI check",
  "保存中…": "Saving…",
  "保存为新版本": "Save as new version",
  "正在查看历史版本 #{viewed.id}（非当前生效版本）。": "Viewing past version #{viewed.id} (not the active version). ",
  "返回当前版本": "Back to active version",
  "版本 #{shown.id} ·": "Version #{shown.id} ·",
  " · 人工修订{0}（基于版本 #{shown.baseId}）": " · Manually revised{0} (based on version #{shown.baseId})",
  " · AI 生成{0}": " · AI generated{0}",
  " · 依据学习资源库 {shown.sourceTopicIds.length} 个主题": " · Based on {shown.sourceTopicIds.length} Resource Library topics",
  " · 满分 {content.totalScore}": " · Max score {content.totalScore}",
  "修订说明：{shown.changeNote}": "Revision note: {shown.changeNote}",
  "保存时已知悉的核查提醒（{cautionCount(shown.cautions)} 条）": "Check notes acknowledged at save time ({cautionCount(shown.cautions)})",
};
export default en;
